import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subscript",
  "use": "icon-subscript-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\" id=\"icon-subscript\">\n            <path d=\"M1 1.25L5.5 5.75L10 1.25\" stroke=\"#646464\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n          </symbol>"
});
var result = sprite.add(symbol);
export default symbol